export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-1024w.86af2cf6.avif";